import { trpcClient } from 'shared/api'
import type { DriverTakeRequest } from './DriverCashBags'

/** The driver's Cash bag calls on the real tRPC client — the defaults of `Driver`'s seams (ticket 31). */
export const cashBagsViaTrpc = (tripId: string) => trpcClient.cashBags.ForTrip.query({ tripId })
export const takeViaTrpc = (input: DriverTakeRequest) => trpcClient.cashBags.Take.mutate(input)
